/**
 * Constants related to events triggered within Weggie.
 */
export enum EVENT {
  PRINT = 'wr-printer:print',
  LINE_ITEM_UPDATE_VALIDATION = 'line-item:update-validation',
  SALE_ADD_LINE_ITEM = 'sale:add-line-item',
  SALE_ADD_UNKNOWN_LINE_ITEM = 'sale:add-unknown-line-item',
  SALE_CUSTOMER_UPDATED = 'sale:customer-updated',
  SALE_UPDATE_TENDERED_AMOUNT = 'sale:update-tendered-amount',
  SEARCH_PRODUCT_SELECTED = 'search:product-selected',
}
